import { createSelector } from 'reselect';
import * as $_ from 'global/functions';

const allProcesses = (state) => state.processes.allProcesses;

const basicSearchValues = ['phone', 'email'];

export const filterProcess = createSelector(
  allProcesses,
  (processList) => (searchValue, filter, sortBy, sortOrder) => {
    let returnValue = processList || [];
    if (!returnValue || returnValue.length === 0) return [];
    //    if (filter.title) returnValue = returnValue.filter(a => a.salesStep <= filter.value);
    if (searchValue) {
      returnValue = returnValue.filter((process) => (
        $_.matchable(
          process.sales_scope,
          'client_id',
          searchValue,
        ) || $_.matchable(
          process.sales_scope.customer,
          basicSearchValues,
          searchValue,
        ) || $_.matchable(
          process.applicant,
          'name',
          searchValue,
        ) || $_.matchable(
          process,
          'identifier',
          searchValue,
        )
      ));
    }
    if (sortBy) {
      switch (sortBy) {
        case 'name':
          returnValue = returnValue.sort((a, b) => {
            if (a.applicant[sortBy] < b.applicant[sortBy]) {
              return sortOrder ? -1 : 1;
            }
            if (a.applicant[sortBy] > b.applicant[sortBy]) {
              return sortOrder ? 1 : -1;
            }
            return 0;
          });
          break;
        case 'confirmed_date':
        case 'align_date':
        case 'client_id':
          returnValue = returnValue.sort((a, b) => {
            const firstValue = a.sales_scope[sortBy] || '';
            const secondValue = b.sales_scope[sortBy] || '';
            if (firstValue < secondValue) {
              return sortOrder ? -1 : 1;
            }
            if (firstValue > secondValue) {
              return sortOrder ? 1 : -1;
            }
            return 0;
          });
          break;
        default:
          returnValue = returnValue.sort((a, b) => {
            if (a[sortBy] < b[sortBy]) {
              return sortOrder ? -1 : 1;
            }
            if (a[sortBy] > b[sortBy]) {
              return sortOrder ? 1 : -1;
            }
            return 0;
          });
          break;
      }
    }

    return Array.from(returnValue);
  },
);
